import React from "react"
import FeePresenterGeneral from "./tabs/FeePresenterGeneral"
import FeePresenterRates from "./tabs/FeePresenterRates"
import FeePresenterProducts from "./tabs/FeePresenterProducts"
import FeePresenterCancellationRules from "./tabs/FeePresenterCancellationRules"
import FeePresenterGuestTypes from "./tabs/FeePresenterGuestTypes"
import FeePresenterTaxes from "./tabs/FeePresenterTaxes"
import FeePresenterFees from "./tabs/FeePresenterFees"
import FeePresenterHistory from "./tabs/FeePresenterHistory"

export default class FeePresenterTabContent extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div className="tab-content">
        <FeePresenterGeneral {...this.props} />
        <FeePresenterProducts {...this.props} />
        {!this.props.tax ? <FeePresenterTaxes {...this.props}  /> : null}
        {/* <FeePresenterCancellationRules {...this.props} /> */}
        {!this.props.tax ? <FeePresenterGuestTypes {...this.props} /> : null}
        <FeePresenterRates {...this.props} />
        {this.props.tax ? <FeePresenterFees {...this.props} /> : null}
        {!this.props.historical_version ? <FeePresenterHistory {...this.props} /> : null}
      </div>
     )
  }
}
